export default "__VITE_ASSET__DqvxqOIb__"